import React from "react";
import { useDropzone } from "react-dropzone";

function ImageDropPreview({ file, onDrop }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/*',
    maxSize: 5242880,
    multiple: false,
  });
  const imageUrl = typeof file === "string" ? file : URL.createObjectURL(file);
  return (
    <div
      {...getRootProps()}
      className={`border-2 border-dashed flex items-center justify-center flex-col rounded-lg p-4 text-center cursor-pointer transition-colors w-full max-w-xs ${
        isDragActive ? "border-blue-400 bg-blue-50" : "border-gray-300 bg-gray-50 hover:border-gray-400"
      }`}
      style={{ minHeight: 180 }}
    >
      <input {...getInputProps()} />
      <div className="flex items-center justify-center w-full h-full">
        <img
          src={imageUrl}
          alt="Uploaded Preview"
          className="rounded-lg shadow-md border border-gray-200 object-cover w-full h-full bg-white"
        />
      </div>
      <span className="block text-xs text-violet-600 mt-1">Click or drop a new image to change</span>
    </div>
  );
}

export default ImageDropPreview;
